import { Component, OnInit, Input, EventEmitter } from '@angular/core'
import { ActionComponent, Module, Payload } from '@bp/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { SharedHttpService } from '~/shared/http/shared-http.service'
import { Router } from '@angular/router'
import { NzMessageService } from 'ng-zorro-antd'

@Component({
  selector: 'app-template-refresh-sequence',
  templateUrl: './template-refresh-sequence.component.html',
  styleUrls: ['./template-refresh-sequence.component.styl'],
})
export class TemplateRefreshSequenceComponent extends ActionComponent implements OnInit {
  static meta = {
    type: 'custom_action',
    name: 'template-refresh-sequence',
  }

  validateForm = this._fb.group({
    sequence: [null, Validators.required],
  })

  dispatch = new EventEmitter<Payload>()

  formStyle = {
    offset: 5,
    span: 15,
  }

  fields = [
    {
      name: '增减排序值',
      identifier: 'sequence',
      type: 'text',
      extra: 'number',
      place: [],
      feature: [],
      form: {
        type: 'text',
        placeholder: '增减排序值为相对值，非绝对值',
      },
    },
  ]

  @Input() entity: any
  @Input() module: Module

  showModal = false

  bpOnClick = () => {
    this.openModal()
  }

  constructor(
    private _fb: FormBuilder,
    private _router: Router,
    private _sharedHttp: SharedHttpService,
    private _msgService: NzMessageService,
  ) {
    super()
  }

  ngOnInit() {}

  openModal() {
    this.showModal = true
    this.validateForm.reset()

  }

  closeModal() {
    this.showModal = false
  }

  handleOk() {
    if (this.entity) {
      this._sharedHttp.templateBatch(
        this.entity.id,
        'sequence',
        { sequence: this.validateForm.get('sequence').value }
      ).subscribe(res => {
        this._msgService.success('操作成功')
        this.dispatch.emit({ type: 'refresh' })
      })
    } else {
      this.dispatch.emit({
        type: 'batch',
        batchType: 'sequence',
        data: { sequence: this.validateForm.get('sequence').value },
      })
    }

    this.showModal = false
  }
}
